import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { getBankTransferDetails } from "../../network";
import { Button } from "antd";

export default function BankTransfer({ itemId, onBack, onContinue }) {
  const [bankTransferDetails, setBankTransferDetails] = useState(null);
  const { dir } = useSelector((state) => state.language);
  const { t } = useTranslation();

  useEffect(() => {
    getBankTransferDetails(
      itemId,
      (res) => {
        setBankTransferDetails(res?.data);
      },
      () => {},
    );
  }, [itemId]);

  return (
    <div className="bank-transfer-info">
      <h3
        className={`text-center fsize-4 fw-bold green-text mb-3 ${dir === "rtl" ? "text-end" : "text-start"}`}
      >
        {t("home.itemModal.bankTransfer.title")}
      </h3>

      <div className="bank-transfer-info__details">
        {[
          {
            label: t("home.itemModal.bankTransfer.bankName"),
            value: bankTransferDetails?.bankName ?? "—",
          },
          {
            label: t("home.itemModal.bankTransfer.accountName"),
            value: bankTransferDetails?.accountName ?? "—",
          },
          {
            label: t("home.itemModal.bankTransfer.accountNumber"),
            value: bankTransferDetails?.accountNumber ?? "—",
          },
          {
            label: t("home.itemModal.bankTransfer.branchName"),
            value: bankTransferDetails?.branchName ?? "—",
          },
          {
            label: t("home.itemModal.bankTransfer.iban"),
            value: bankTransferDetails?.iban ?? "—",
          },
        ].map(({ label, value }) => (
          <div key={label} className={`d-flex flex-column py-2 border-bottom`}>
            <span className="fsize-9 fw-bold">{label}</span>
            <span className="fsize-9">{value}</span>
          </div>
        ))}
      </div>

      <div className="row mt-4 m-0">
        <div
          className={`col-6 ${
            dir === "ltr" ? "ps-0 pe-3 pe-lg-4" : "pe-0 ps-3 ps-lg-4"
          }`}
        >
          <Button
            className="invoice__btn invoice__btn--back w-100 fsize-5 border-0 fw-bold h-auto d-block text-white"
            onClick={onBack}
          >
            {t("home.itemModal.bankTransfer.back")}
          </Button>
        </div>

        <div
          className={`col-6 ${
            dir === "ltr" ? "ps-0 pe-3 pe-lg-4" : "pe-0 ps-3 ps-lg-4"
          }`}
        >
          <Button
            className="invoice__btn invoice__btn--submit w-100 fsize-5 border-0 fw-bold h-auto d-block text-white"
            onClick={onContinue}
          >
            {t("home.itemModal.bankTransfer.continue")}
          </Button>
        </div>
      </div>
    </div>
  );
}
